import React from 'react';
import { TaskSection } from 'components/common/TaskSection';
import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FieldV2 } from 'components/common/form-controls';

import styles from './procurementOrderContent.style';

const EquipmentDetails = ({ index }) => {
  const methods = useFormContext();

  return (
    <TaskSection title="Equipment Details" isEmbedded>
      <Grid container spacing={1.5}>
        <Grid size={4}>
          <FieldV2
            label="Spare Tyre"
            name={`skuGroups.${index}.equipmentDetails.spareTyre`}
            type="checkbox"
            control={methods.control}
            wrapperStyle={styles.checkBoxWrapper}
          />
        </Grid>
        <Grid size={4}>
          <FieldV2
            label="Repair Kit"
            name={`skuGroups.${index}.equipmentDetails.repairKit`}
            type="checkbox"
            control={methods.control}
            wrapperStyle={styles.checkBoxWrapper}
          />
        </Grid>
        <Grid size={4}>
          <FieldV2
            label="Door Mats"
            name={`skuGroups.${index}.equipmentDetails.doorMats`}
            type="checkbox"
            control={methods.control}
            wrapperStyle={styles.checkBoxWrapper}
          />
        </Grid>
        <Grid size={4}>
          <FieldV2
            label="Home Charger"
            name={`skuGroups.${index}.equipmentDetails.homeCharger`}
            type="checkbox"
            control={methods.control}
            wrapperStyle={styles.checkBoxWrapper}
          />
        </Grid>
        <Grid size={4}>
          <FieldV2
            label="Fast Charger"
            name={`skuGroups.${index}.equipmentDetails.fastCharger`}
            type="checkbox"
            control={methods.control}
            wrapperStyle={styles.checkBoxWrapper}
          />
        </Grid>
      </Grid>
    </TaskSection>
  );
};

export default EquipmentDetails;
